import Layout from "../Layout";
import PlanCard from "./PlanCard";
import CouponField from "../../CouponField";
import {ButtonPrimary} from "../../../../../common/components/library/Button";
import { WhatsAppInfoBanner } from "components/InfoBanner";

import useEntityStore from "../../../store/entityStore";
import useAppState from "../../../store/appState";
import ScreenTypes from "../../../constants/screenTypes";
import useCouponState from "../../../store/couponState";


export default function PlanSelection () {
  const entity = useEntityStore(state => state.entity?.data);
  const couponDUMMY = useCouponState(state => state.coupon);
  const [order, setActiveScreen] = useAppState(state => [state.order, state.setActiveScreen]);
  const selectedPlan = useAppState(state => state.selectedPlan);

  const plans = entity?.payment.plans;
  const handleClick = () => {
    setActiveScreen(ScreenTypes.CUSTOMER_FORM_1);
  };

  const payButtonLabel = order.getPayButtonLabel;

  return (
    <div className="w-full">
      <Layout className="h-full overflow-x-hidden">
        <WhatsAppInfoBanner />
        <div className="grid grid-cols-1 gap-4 pt-3">
          {
            plans.map((plan, index) => (
              <PlanCard
                key={plan.data.uid}
                data={plan.data}
                isSelected={selectedPlan?.data.uid === plan.data.uid}
              />
            ))
          }
        </div>
        {
          order.isRecurring && (
            <div className="mt-4">
              <CouponField />
            </div>
          )
        }
      </Layout>
      <div
        className="absolute bottom-0 pb-6 pt-2 px-4 w-full left-0"
        style={{
          backgroundImage: 'linear-gradient(to top, #fff, rgba(255,255,255,0.35))'
        }}
      >
        <ButtonPrimary
          className="w-full animate-glimmer-pay overflow-hidden hover:scale-[1.02] duration-120 transition-all ease-[cubic-bezier(.3,1.35,1,1) bg-primary"
          onClick={handleClick}
        >
          <div className="flex flex-col justify-center">
            {payButtonLabel.label}
            {
              payButtonLabel.subLabel && (
                <span className="text-[11px] leading-4 font-normal">
                  {payButtonLabel.subLabel}
                </span>
              )
            }
          </div>
        </ButtonPrimary>
      </div>
    </div>
  );
}

PlanSelection.title = "Select your plan";
